import React from 'react';
import { motion } from 'framer-motion';
import { MoneyEvaporateIcon, AnxietyIcon, IceIcon, SadIcon, CycleIcon, BrainIcon } from './Icons';
export function Problem() {
  const symptoms = [{
    icon: <MoneyEvaporateIcon className="w-6 h-6 text-gold" data-id="element-255" />,
    title: 'El dinero se evapora',
    desc: 'Recibes dinero extra y en días desaparece sin saber realmente en qué.'
  }, {
    icon: <AnxietyIcon className="w-6 h-6 text-gold" data-id="element-256" />,
    title: 'Ansiedad financiera constante',
    desc: 'Sientes tensión en el pecho solo de pensar en revisar tu cuenta bancaria.'
  }, {
    icon: <IceIcon className="w-6 h-6 text-gold" data-id="element-257" />,
    title: 'Parálisis ante oportunidades',
    desc: 'Ves oportunidades claras pero algo te detiene siempre en el último momento.'
  }, {
    icon: <SadIcon className="w-6 h-6 text-gold" data-id="element-258" />,
    title: 'Cobras menos de lo que vales',
    desc: 'Sientes culpa o miedo de pedir lo que realmente vale tu trabajo.'
  }, {
    icon: <CycleIcon className="w-6 h-6 text-gold" data-id="element-259" />,
    title: 'El ciclo que no termina',
    desc: 'Trabajo, gano, gasto, deuda. El mismo patrón se repite año tras año.'
  }, {
    icon: <BrainIcon className="w-6 h-6 text-gold" data-id="element-260" />,
    title: 'Las afirmaciones no funcionan',
    desc: 'Repites soy próspero pero tu cuerpo siente exactamente lo contrario.'
  }];
  return <section className="bg-primary py-10 md:py-16 px-4 md:px-12" data-id="element-261">
      <div className="max-w-5xl mx-auto" data-id="element-262">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-12 md:mb-16" data-id="element-263">
          <h2 className="font-playfair font-bold text-3xl md:text-5xl text-warm-white mb-4" data-id="element-264">
            ¿Por qué el dinero llega pero no se queda?
          </h2>
          <p className="font-playfair italic text-xl md:text-2xl text-gold mb-6 md:mb-8" data-id="element-265">
            No es tu culpa. Es tu biología.
          </p>
          <div className="w-16 h-1 bg-gold mx-auto mb-6 md:mb-8 rounded-full" data-id="element-266"></div>
          <p className="font-inter text-base md:text-lg text-warm-muted max-w-3xl mx-auto leading-relaxed px-2" data-id="element-267">
            Si trabajas duro, conoces estrategias financieras, lees libros de
            prosperidad y aun así el dinero no llega o se escapa entre tus dedos
            cada vez que aparece... el problema no está en tu esfuerzo. Está en
            tu sistema nervioso.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-12 md:mb-20" data-id="element-268">
          {symptoms.map((symptom, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: idx * 0.1
        }} className="bg-secondary p-5 md:p-6 rounded-lg border-l-4 border-gold shadow-lg text-center" data-id="element-269">
              <div className="mb-4 bg-card w-12 h-12 rounded-full flex items-center justify-center mx-auto" data-id="element-270">
                {symptom.icon}
              </div>
              <h3 className="font-inter font-bold text-lg md:text-xl text-warm-white mb-2 md:mb-3" data-id="element-271">
                {symptom.title}
              </h3>
              <p className="font-inter text-sm md:text-base text-warm-muted leading-relaxed" data-id="element-272">
                {symptom.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-secondary border border-gold rounded-2xl p-6 md:p-12 text-center max-w-4xl mx-auto shadow-glow-gold" data-id="element-273">
          <p className="font-inter text-lg md:text-2xl text-warm-white leading-relaxed mb-4 md:mb-6" data-id="element-274">
            "La manifestación tradicional falla porque intenta cambiar tu
            realidad financiera desde la mente. El Protocolo RNS la cambia desde
            donde realmente vive el problema:"
          </p>
          <div className="font-playfair font-bold text-3xl md:text-5xl text-gold" data-id="element-275">
            Tu sistema nervioso.
          </div>
        </motion.div>
      </div>
    </section>;
}